import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Analytics } from '@vercel/analytics/react';
import MyNavbar from './components/Navbar';
import About from './pages/About';
import ProjectIndex from './pages/ProjectIndex';
import ProjectDetailsPage from './pages/ProjectDetailsPage';
import BlogIndex from './pages/BlogIndex';
import BlogPostPage from './pages/BlogPostPage';
import Resume from './pages/files/Resume';
import './App.css';

function App() {
  return (
    <Router>
      <MyNavbar />
      <Analytics />
      <Routes>
        <Route path="/" element={<About />} />
        <Route path="/projects" element={<ProjectIndex />} />
        <Route path="/projects/:slug" element={<ProjectDetailsPage />} />
        <Route path="/blog" element={<BlogIndex />} />
        <Route path="/blog/:slug" element={<BlogPostPage />} />
        <Route path="/resume" element={<Resume />} />
      </Routes>
    </Router>
  );
}

export default App;